import * as React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
const RawHamburger = ({ onClick, className }) => (React.createElement("button", { onClick: onClick, className: className },
    React.createElement("span", { className: "icon-bar" }),
    React.createElement("span", { className: "icon-bar" }),
    React.createElement("span", { className: "icon-bar" })));
const Hamburger = styled(RawHamburger) `
  position: absolute;
  border: none;
  top: 0;
  left: 0;
  background: transparent;
  height: 60px;
  outline: none;
  border-radius: 0;
  padding: 0 20px;

  span {
    background: ${THEME.COLOR_PRIMARY};
    margin-bottom: 4px;
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    transition: 0.25s ease-in-out;

    &:nth-child(1) {
      transform: ${({ open }) => `rotate(${open ? 45 : 0}deg) translate(${open ? '4px, 4.5px' : '0,0'})`};
    }

    &:nth-child(2) {
      opacity: ${({ open }) => (open ? 0 : 1)};
    }

    &:nth-child(3) {
      transform: ${({ open }) => `rotate(-${open ? 45 : 0}deg) translate(${open ? '4px, -4.5px' : '0,0'})`};
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media ${THEME.MEDIA_QUERY_MOBILE} {
    display: block;
  }
`;
Hamburger.displayName = 'Hamburger';
export default Hamburger;
//# sourceMappingURL=Hamburger.js.map